export const SUPPORT_CHAT_CONVERSATION_QUERY_KEY = 'supportChatConversation';

export const supportChatKeys = {
  conversation: () => [SUPPORT_CHAT_CONVERSATION_QUERY_KEY] as const,
};
